import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import AddEditFormCst from "@components/AddEditFormCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import ButtonBackPage from "../../../../../../components/ButtonBackPage";
import { useParams } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { axiosInstance } from "../../../../../../services/config";
import { useFetchDataDetail } from "../../../../../../hooks/useFetchDetail";

const AddCampaign: React.FC = () => {
  const { t } = useTranslation(["training-needs-campaign-page"]);
  const { t: tModal } = useTranslation(["modal"]);
  const { t: tForm } = useTranslation(["form"]);
  const { id } = useParams();
  const { columns } = useFetchDataDetail(
    `${ServicesURL.digitedTipologyCampaign}`
      .replace("{campaignType}", "UOG")
      .replace("{corporateId}", `${id}`),
    PagesID["corporate.campaign"],
  );
  const [dataGroup, setDataGroup] = useState([]);
  const [dataUog, setDataUog] = useState<string[]>([]);

  const filteredVisibilityColumn = columns?.filter(
    (el: any) => el.visibility !== false,
  );

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const { trigger: addCampaign } = useSWRMutation(
    ServicesURL.digitedCampaign + `?corporate_id=${id}`,
    (url: string, arg: { arg: any }) => {
      return () => axiosInstance.post(`${url}`, arg.arg);
    },
  );

  const { trigger: getGroups } = useSWRMutation(
    `${ServicesURL.groups.replace(":idCorporate", `${id}`)}/groups`,
    (url: string, arg: { arg: any }) => {
      return () => axiosInstance.get(`${url}`, arg.arg);
    },
  );

  const { trigger: getUog } = useSWRMutation(
    `${ServicesURL.corporateOrganizationTree.replace(
      "{corporateId}",
      `${id}`,
    )}`,
    (url: string) => {
      return () => axiosInstance.get(`${url}`);
    },
  );

  useEffect(() => {
    getGroups().then((resp: any) =>
      setDataGroup(resp.data && resp.data.output),
    );
    getUog().then((resp: any) => {
      const uniqueCodes: string[] = Array.from(
        new Set(
          resp.data.tree.map((item: any) => {
            return {
              code: item.code,
              description: item.description,
              parent_code: item.parent_code,
            };
          }),
        ),
      );
      setDataUog(uniqueCodes);
    });
  }, []);

  const onSubmit = async (inputForm: any) => {
    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });

    const buildLevels = (data: any) => {
      const levels: any = {};
      const rootItem = data.find((el: any) => el.parent_code == "NULL");

      function getLevelItems(parentCode: string, level: number) {
        if (!levels[level]) levels[level] = [];
        const items = data.filter(
          (item: any) => item.parent_code === parentCode,
        );

        if (items.length === 0) return;
        levels[level].push(...items);
        items.forEach((item: any) => getLevelItems(item.code, level + 1));
      }

      if (rootItem) {
        getLevelItems(rootItem.code, 1);
      }
      const fullLevels = {
        "0": [rootItem],
        ...levels,
      };
      return fullLevels;
    };

    const dataLevelsBuild = buildLevels(dataUog);
    /*
    :TODO cancellare se la fix fix(fabbisogni-formativi):getione errore UOG e fix logica sezione Organizzativa
    console.log({dataLevelsBuild,val:inputForm})
    const payloadLevelsManager = inputForm?.section_manager?.selectedLevels
      .map((el: any) => dataLevelsBuild[el.name].map((data: any) => data.code))
      .flat()||[];
    const payloadLevelHr = inputForm?.section_hr?.selectedLevels
      .map((el: any) => dataLevelsBuild[el.name].map((data: any) => data.code))
      .flat()||[];
*/
    const fullLevels = Object.keys(dataLevelsBuild)
      .filter((levelIndex) => dataLevelsBuild[levelIndex]?.length > 0)
      .map((levelIndex) => ({
        name: `${levelIndex}`,
        value: levelIndex,
        label: `${levelIndex}`,
      }));

    const getDataLevelsManager =
      inputForm.section_manager &&
      inputForm.section_manager.selectedLevels == "allLevels"
        ? fullLevels
        : inputForm.section_manager &&
          inputForm.section_manager.selectedLevels &&
          inputForm.section_manager.selectedLevels;
    const getDataLevelsHR =
      inputForm.section_hr &&
      inputForm.section_hr.selectedLevels &&
      inputForm.section_hr.selectedLevels == "allLevels"
        ? getDataLevelsManager
          ? getDataLevelsManager
          : fullLevels
        : inputForm.section_hr &&
          inputForm.section_hr.selectedLevels &&
          inputForm.section_hr.selectedLevels;

    const getDataGroupLearner =
      inputForm.section_learner &&
      inputForm.section_learner.selectedGroups &&
      inputForm.section_learner.selectedGroups == "all"
        ? dataGroup
        : inputForm.section_learner &&
          inputForm.section_learner.selectedGroups &&
          inputForm.section_learner.selectedGroups;
    const getDataGroupManager =
      inputForm.section_manager &&
      inputForm.section_manager.selectedGroups &&
      inputForm.section_manager.selectedGroups == "all"
        ? dataGroup
        : inputForm.section_manager &&
          inputForm.section_manager.selectedGroups &&
          inputForm.section_manager.selectedGroups;
    const getDataGroupHR =
      inputForm.section_hr &&
      inputForm.section_hr.selectedGroups &&
      inputForm.section_hr.selectedGroups == "all"
        ? dataGroup
        : inputForm.section_hr &&
          inputForm.section_hr.selectedGroups &&
          inputForm.section_hr.selectedGroups;

    const payloadLevelsManager =
      getDataLevelsManager &&
      getDataLevelsManager
        .map((el: any) =>
          dataLevelsBuild[el.name].map((data: any) => data.code),
        )
        .flat();

    const payloadLevelsHR =
      getDataLevelsHR &&
      getDataLevelsHR
        ?.map((el: any) =>
          dataLevelsBuild[el.name].map((data: any) => data.code),
        )
        .flat();

    const payloadGroupsLearner =
      getDataGroupLearner &&
      getDataGroupLearner.map((el: any) => {
        return { id: el.id, group_type: el.type };
      });
    const payloadGroupsManager =
      getDataGroupManager &&
      getDataGroupManager.map((el: any) => {
        return { id: el.id, group_type: el.type };
      });
    const payloadGroupsHr =
      getDataGroupHR &&
      getDataGroupHR.map((el: any) => {
        return { id: el.id, group_type: el.type };
      });

    /*
 :TODO cancellare se la fix fix(fabbisogni-formativi):getione errore UOG e fix logica sezione Organizzativa
    const objToSend: any = {
      corporate_id: id,
      campaign_type: "UOG",
      name: inputForm["campaign_name"] || "",
      campaign_year: inputForm.campaign_year
        ? inputForm.campaign_year.$y.toString()
        : "",
      uog_aggregation_level: inputForm["uog_aggregation_level"],
      ...(inputForm.section_learner &&
        inputForm.section_learner.selectedGroups && {
          learner_level: {
            groups: inputForm.section_learner.selectedGroups.map((el: any) => {
              return { id: el.id, group_type: el.type };
            }),
          },
        }),
      ...(inputForm.section_manager &&
        inputForm.section_manager.selectedGroups && {
          manager_level: {
            groups: inputForm.section_manager.selectedGroups.map((el: any) => {
              return { id: el.id, group_type: el.type };
            }),
            level_ids: payloadLevelsManager,
          },
        }),
      ...(inputForm.section_hr &&
        inputForm.section_hr.selectedGroups && {
          hr_level: {
            groups: inputForm.section_hr.selectedGroups.map((el: any) => {
              return { id: el.id, group_type: el.type };
            }),
            level_ids:payloadGroupsHr,
          },
        }),
    };
*/
    const objToSend: any = {
      corporate_id: id,
      campaign_type: "UOG",
      name: inputForm["campaign_name"] || "",
      campaign_year: inputForm.campaign_year
        ? inputForm.campaign_year.$y.toString()
        : "",
      uog_aggregation_level: inputForm["uog_aggregation_level"],
      ...(inputForm.section_manager &&
        inputForm.section_manager.selectedGroups &&
        inputForm.section_manager.enabled && {
          manager_level: {
            ...(payloadGroupsManager.length && {
              groups: payloadGroupsManager,
            }),
            ...(payloadLevelsManager.length && {
              level_ids: payloadLevelsManager.flat(),
            }),
          },
        }),
      ...(inputForm.section_learner &&
        inputForm.section_learner.selectedGroups &&
        inputForm.section_learner.enabled && {
          learner_level: {
            ...(payloadGroupsLearner.length && {
              groups: payloadGroupsLearner,
            }),
          },
        }),
      ...(inputForm.section_hr &&
        inputForm.section_hr.selectedGroups &&
        inputForm.section_hr.enabled && {
          hr_level: {
            ...(payloadGroupsHr.length && { groups: payloadGroupsHr }),
            ...(payloadLevelsHR.length && {
              level_ids: payloadLevelsHR.flat(),
            }),
          },
        }),
    };

    try {
      await addCampaign(objToSend);
      setOpenToast({
        s: StatusEnum.OK,
        message: tModal("successfully-create-campaign", {
          campaign: inputForm["campaign_name"] || "",
        }),
      });
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        <ButtonBackPage />
        {filteredVisibilityColumn && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              columns={filteredVisibilityColumn}
              onSubmit={onSubmit}
              options={dataGroup}
              optionsSelect={dataUog}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddCampaign;
